import {
  SET_CITIES,
  SET_JOBS,
  SET_PROJECT,
  SET_COMPANY_INFO,
  SET_INSTAGRAM_POST,
} from 'store/mutations';

import {
  fetchJobs,
  fetchProjectBySlug,
  fetchInstagramRecentPost,
  fetchCompanyInfoBySlug,
} from 'data';
import DeprecatedJobs from '../constants/deprecated-jobs';

export const FETCH_JOBS = 'FETCH_JOBS';
export const FETCH_PROJECT_BY_SLUG = 'FETCH_PROJECT_BY_SLUG';
export const FETCH_INSTAGRAM_RECENT_POST = 'FETCH_INSTAGRAM_RECENT_POST';
export const FETCH_COMPANY_INFO_BY_SLUG = 'FETCH_COMPANY_INFO_BY_SLUG';

export const SEND_RESUME = 'SEND_RESUME';
const HIDDEN_JOB_CODE_SUFFIX = '_hidden';

/**
 * Returns city slug by city name.
 *
 * @param {string} name Name of the city
 * @return {string}
 */
function citySlug(name) {
  return name
    .trim()
    .toLowerCase()
    .replace(/\s/g, '-');
}

function translateCity(name) {
  const cities = {
    Ekaterinburg: 'Екатеринбург',
    Krasnoyarsk: 'Красноярск',
    Sochi: 'Сочи',
  };

  return cities[name] || null;
}

function filterDisallowedCities(cities) {
  const allowedCities = ['Ekaterinburg', 'Krasnoyarsk', 'Sochi'];

  return cities.filter(city => allowedCities.indexOf(city.name) !== -1);
}

/**
 * Initializes list of cities and builds cities objects.
 *
 * @param {string[]} cities List of cities names
 * @return {{name: string, url: string}[]}
 */
function initializeCities(cities) {
  return cities.map(city => ({
    name: city,
    nameRU: translateCity(city),
    url: citySlug(city),
  }));
}

/**
 * Parse jobs and retrieve list of cities.
 *
 * @param {{city: string}[]} jobs List of jobs
 * @return {*}
 */
function parseCites(jobs) {
  let cities = [];
  jobs.forEach(e => {
    const jobCities = e.city.split(', ');
    cities = cities.concat(jobCities);
  });

  const uniqueCities = cities.filter(
    (item, pos) => cities.indexOf(item) === pos,
  );

  const allCities = initializeCities(uniqueCities);

  return filterDisallowedCities(allCities);
}

/**
 * Get open jobs.
 *
 * @param { {internal_code: string} [] } List of jobs
 * @return {*}
 */
function getOpenJobs(jobs) {
  const openJobs = [];
  jobs.forEach(job => {
    if (!job.internal_code.endsWith(HIDDEN_JOB_CODE_SUFFIX)) {
      openJobs.push(job);
    }
  });

  return openJobs;
}

/**
 * Filter by jobs which not deprecated.
 *
 * @param {Array<Object>} jobs - List of jobs.
 * @returns {Array<Object>} - List of not deprecated jobs.
 */
function filterDeprecatedJobs(jobs) {
  return jobs.filter(job => DeprecatedJobs.indexOf(job.title) === -1);
}

export default {
  [FETCH_JOBS]: ({ commit }) =>
    fetchJobs().then(jobs => {
      const openJobs = getOpenJobs(filterDeprecatedJobs(jobs));

      commit(SET_JOBS, openJobs);

      const cities = parseCites(jobs);
      commit(SET_CITIES, cities);
    }),

  [FETCH_PROJECT_BY_SLUG]: ({ commit }, slug) =>
    fetchProjectBySlug(slug).then(project => {
      commit(SET_PROJECT, project);
    }),

  [FETCH_COMPANY_INFO_BY_SLUG]: ({ commit }, slug) =>
    fetchCompanyInfoBySlug(slug).then(companyInfo => {
      commit(SET_COMPANY_INFO, companyInfo);
    }),

  [FETCH_INSTAGRAM_RECENT_POST]: ({ commit }) =>
    fetchInstagramRecentPost().then(post => {
      commit(SET_INSTAGRAM_POST, post);
    }),
};



// WEBPACK FOOTER //
// ./src/store/actions.js